import { configTextRemoveEmptyLines } from './configTextRemoveEmptyLines.js';
import { configTextRemoveDuplicates } from './configTextRemoveDuplicates.js';
import { configTextRemoveUniques } from './configTextRemoveUniques.js';

import { configTextSort } from './configTextSort.js';
import { configTextSortCaseInsensitive } from './configTextSortCaseInsensitive.js';
import { configTextSortNatural } from './configTextSortNatural.js';
import { configTextRandomize } from './configTextRandomize.js';
import { configTextSortByLength } from './configTextSortByLength.js';
import { configTextReverse } from './configTextReverse.js';

import { configTextTrim } from './configTextTrim.js';
import { configTextTrimLeft } from './configTextTrimLeft.js';
import { configTextTrimRight } from './configTextTrimRight.js';
import { configTextRemoveFirstFewCharacters } from './configTextRemoveFirstFewCharacters.js';
import { configTextRemoveLastFewCharacters } from './configTextRemoveLastFewCharacters.js';
import { configTextRemoveCommaCharacterAtLineEnds } from './configTextRemoveCommaCharacterAtLineEnds.js';
import { configTextRemoveQuoteAndApostropheCharacters } from './configTextRemoveQuoteAndApostropheCharacters.js';

import { configTextGetStats } from './configTextGetStats.js';

import {
    configUnicodeToPunycode,
    configPunycodeToUnicode
} from './configTextPunycode.js';

import { configTextLinesToJsonArray } from './configTextLinesToJsonArray.js';

const modeText = {
    modeId: 'text',
    modeNameForAceEditor: 'text',

    title: 'Text',

    icon: null,

    hasSyntaxHighlighting: false,

    snippets: [{
        content: [
            'Chelsea',
            'Bob',
            'Alice',
            'David'
        ].join('\n')
    }],

    operations: [
        {
            optgroupLabel: 'Lines',
            options: [
                configTextRemoveEmptyLines, // Remove empty lines
                configTextRemoveDuplicates, // Remove duplicates
                configTextRemoveUniques     // Remove uniques
                // Remove beyond N lines
            ]
        },
        {
            optgroupLabel: 'Sort',
            options: [
                configTextSort,                // Sort
                configTextSortCaseInsensitive, // Case-insensitive sort
                configTextSortNatural,         // Natural sort
                configTextRandomize,           // Randomize
                configTextSortByLength,        // Sort by length
                configTextReverse              // Reverse
            ]
        },
        {
            optgroupLabel: 'String',
            options: [
                configTextTrim,                              // Trim lines
                configTextTrimLeft,                          // Trim lines from left
                configTextTrimRight,                         // Trim lines from right
                configTextRemoveFirstFewCharacters,          // Remove first few characters
                configTextRemoveLastFewCharacters,           // Remove last few characters
                configTextRemoveCommaCharacterAtLineEnds,    // Remove comma character at line ends
                configTextRemoveQuoteAndApostropheCharacters // Remove " and ' characters
            ]
        },
        {
            optgroupLabel: 'Stats',
            options: [
                configTextGetStats // Get statistics
                // Count lines        // Icon: FormatListNumberedRtlIcon
                // Count characters   // Icon: AbcIcon
                // Count words        // Icon: SubtitlesIcon
                // Count unique words // Icon: SubtitlesOutlinedIcon
            ]
        },
        {
            optgroupLabel: 'Encoding/Decoding',
            options: [
                configUnicodeToPunycode, // Unicode to Punycode
                configPunycodeToUnicode  // Punycode to Unicode
            ]
        },
        {
            optgroupLabel: 'Convert',
            options: [
                configTextLinesToJsonArray // Lines to JSON array
            ]
        }
    ]
};
// eslint-disable-next-line unicorn/no-array-reduce
modeText.arrOperations = modeText.operations.reduce((acc, curr) => {
    return acc.concat(curr.options);
}, []);
// eslint-disable-next-line unicorn/no-array-reduce
modeText.obOperations = modeText.arrOperations.reduce((acc, curr) => {
    acc[curr.operationId] = curr;
    return acc;
}, {});

export { modeText };
